<template>
  <div class="page-wrapper">
    <alert-window ref="alertWindow"></alert-window>
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/regions" style="color: black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Области
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">
                        {{ isNew ? 'Новая область' : 'Редактировать область' }}
                      </div>
                    </div>
                    <div class="region-map">
                      <div id="map" style="width: 100%; height: 1000px"></div>
                    </div>
                    <div class="head-panel visibility">
                      <div v-show="isAdmin" @click="clearRegion" class="clear-region">
                        <i class="fa fa-paint-brush"></i>Очистить область
                      </div>
                    </div>
                    <div class="directory-box region-info-form">
                      <div class="main-content">
                        <div class="form">
                          <div class="fieldset">
                            <label class="fieldset-title">Наименование области</label>
                            <fieldset><input type="text" v-model="name"></fieldset>
                          </div>
                          <div class="fieldset">
                            <label class="fieldset-title">Надбавка, час.</label>
                            <fieldset><input type="number" v-model="surcharge" min="0"></fieldset>
                          </div>
                          <div class="fieldset">
                            <label class="fieldset-title">Услуги</label>
                            <fieldset>
                              <input type="checkbox"
                                     v-model="orderToTrucking">
                              <span>Грузоперевозки</span>
                            </fieldset>
                            <fieldset>
                              <input type="checkbox"
                                     v-model="orderToMover">
                              <span>Грузчики</span>
                            </fieldset>
                            <fieldset>
                              <input type="checkbox"
                                     v-model="orderToFurniture">
                              <span>Сборка мебели</span>
                            </fieldset>
                          </div>
                          <div v-show="isAdmin" class="buttons">
                            <button type="button" class="save-button" @click="save">Сохранить</button>
                            <span class="delete" v-show="!isNew" @click="remove">
                              <i class="fa fa-trash-o"></i>Удалить область</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import AlertWindow from '@/components/AlertWindow.vue'
    import api from '@/api'

    export default {
  name: 'Region',
  components: { AlertWindow, HeaderDispatcher, MenuDispatcher },

  data () {
    return {
      orderToTrucking: false,
      orderToMover: false,
      orderToFurniture: false,
      region: {},
      newRegion: {},
      regions: {},
      regionsMap: {},
      regionPolygons: {},
      polygonsList: [],
      polygonsListForMap: [],
      isNew: false,
      regMap: {},
      regionPolygon: {},
      regionEditCompleteBtn: {},
      isAdmin: this.$store.getters.roleCode === 'ROLE_SUPER_ADMIN'
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.region.name : this.newRegion.name
      },

      set (name) {
        !this.isNew ? this.region.name = name : this.newRegion.name = name
      }
    },

    surcharge: {
      get () {
        return !this.isNew ? this.region.surcharge : this.newRegion.surcharge
      },

      set (surcharge) {
        !this.isNew ? this.region.surcharge = surcharge : this.newRegion.surcharge = surcharge
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.initRegionMap().then(
      map => {
        let id = this.$route.params.id
        if (id == 'new') {
          this.isNew = true
          this.newRegion = {
            name: null,
            surcharge: 0,
            orderToTrucking: true,
            orderToMover: true,
            orderToFurniture: true,
            points: [],
          }
          this.addRegion(map)
        } else {
          api
            .getRegionById(id)
            .then(region => {
              if (region) {
                this.region = region
                this.orderToTrucking = region.orderToTrucking
                this.orderToMover = region.orderToMover
                this.orderToFurniture = region.orderToFurniture
                this.editRegion(id)
              }
            })
        }
      })
  },
  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    save () {
      let regPoints = this.regionPolygon.geometry.getCoordinates()[0].reduce((l, x) => {
        l.push(
          {
            lat: x[0],
            lng: x[1]
          }
        )
        return l
      }, [])

      if (this.name) {
        if (this.surcharge !== undefined && this.surcharge !== '') {
          if (regPoints.length > 3 &&
                  (!this.hasIntersections(this.regionPolygon.geometry.getCoordinates()[0]) || confirm("Имеются одинаковые услуги на пересечении двух областей."))) {
            if (this.isNew) {
              this.newRegion.points = regPoints
              this.newRegion.orderToTrucking = this.orderToTrucking;
              this.newRegion.orderToMover = this.orderToMover;
              this.newRegion.orderToFurniture = this.orderToFurniture;
              api
                .createRegion(this.newRegion)
                .then(() => {
                  this.$router.push('/directories/regions')
                  alert('Сохранено')
                })
                .catch(err => alert(err))
            } else {
              this.region.points = regPoints
              this.region.orderToTrucking = this.orderToTrucking;
              this.region.orderToMover = this.orderToMover;
              this.region.orderToFurniture = this.orderToFurniture;
              api
                .updateRegion(this.$route.params.id, this.region)
                .then(() => {
                  this.$router.push('/directories/regions')
                  alert('Сохранено')
                })
                .catch(err => alert(err))
            }
          }
        } else {
          this.$refs.alertWindow.show('Ошибка', 'Введите надбавку', true)
        }
      } else {
        this.$refs.alertWindow.show('Ошибка', 'Введите название', true)
      }
    },

    remove () {
      api
        .deleteRegionById(this.region.id)
        .then(() => {
          this.$router.push('/directories/regions')
          alert('Удалено')
        })
        .catch(err => alert(err))
    },

    initRegionMap () {
      return new Promise((resolve, reject) => {
        ymaps.ready(() => {
          this.regMap = new ymaps.Map('map', {
            center: [55.796289, 49.108795],
            zoom: 12,
            controls: []
          }, {
            searchControlProvider: 'yandex#search',
            suppressMapOpenBlock: true
          })
          this.regionEditCompleteBtn = new ymaps.control.Button({
            data: {
              content: 'Завершить формирование области'
            },
            options: {
              maxWidth: 300,
              visible: false
            }
          })
          this.regionEditCompleteBtn.events.add('click', () => {
            this.regionPolygon.editor.stopDrawing()
            this.regionPolygon.editor.stopEditing()
          })
          this.regMap.controls.add(this.regionEditCompleteBtn)

          // словарь многоугольников для манипулирания ими
          this.polygonsList = []

          // список многоугольников для вывода на карту
          this.polygonsListForMap = new ymaps.GeoObjectCollection()


          api
            .getRegions()
            .then(regs => {
              if (regs) {
                this.regions = regs
                for (let i = 0; i < regs.length; i++) {
                  // создаем многоугольник
                  let pol = new ymaps.Polygon(
                    // формируем список координат региона в виде [ [lat, lng], .. , [lat, lng] ]
                    [regs[i].points.reduce((l, x) => {
                      l.push([x.lat, x.lng])
                      return l
                    }, [])],

                    // по умолчанию многоугольник будет с такими характеристиками
                    {}, {
                      fillColor: '#276391',
                      opacity: 0.5,
                      strokeWidth: 5,
                      editorMenuManager: (items) => {
                        return items.slice(0, -1)
                      }
                    }
                  )

                  // ключ - id региона, значение - многоугольник
                  this.polygonsList[regs[i].id] = pol

                  this.regionsMap[regs[i].id] = regs[i]

                  // добавляем в список многоугольников карты
                  this.polygonsListForMap.add(pol)
                }
                // добавляем на карту список полигонов
                this.regMap.geoObjects.add(this.polygonsListForMap)
              }
            })

          resolve(this.regMap)
        })
      })
    },

    addRegion (map) {
      ymaps.ready(() => {
        // Создаем многоугольник без вершин.
        this.regionPolygon = new ymaps.Polygon([], {}, {
          name: 'newRegion',
          // Курсор в режиме добавления новых вершин.
          editorDrawingCursor: 'crosshair',
          // editorMaxPoints: 6,
          fillColor: '#fc895d',
          strokeColor: '#00FF00',
          opacity: 0.6,
          strokeWidth: 5,
          editorMenuManager: (items) => {
            return items.slice(0, -1)
          }
        })
        // Добавляем многоугольник на карту.
        map.geoObjects.add(this.regionPolygon)

        this.startDrawingNewRegion()
      })
    },

    editRegion (id) {
      // пауза для того чтобы успеть загрузить текущую область
      window.setTimeout(() => {
        this.regionPolygon = this.polygonsList[id]
        this.regionPolygon.options.set('fillColor', '#fc895d')
        this.regionPolygon.options.set('strokeColor', '#f94400')
        this.regionEditCompleteBtn.options.set('visible', true)
        this.regionPolygon.editor.startEditing()
      }, 1000)
    },

    clearRegion () {
      this.regionPolygon.geometry.setCoordinates([])
      this.regionEditCompleteBtn.deselect()
      this.startDrawingNewRegion()
      document.getElementsByClassName('directorys-page')[0].scrollTop = 0
    },

    startDrawingNewRegion () {
      this.regionEditCompleteBtn.options.set('visible', true)
      this.regionPolygon.options.set('editorDrawingCursor', 'crosshair')
      // Включаем режим редактирования с возможностью добавления новых вершин.
      this.regionPolygon.editor.startDrawing()
    },

    hasIntersections (regionPoints) {
      let has = false

      this.regions.forEach(r => {
        if (this.polygonsList[r.id] !== this.regionPolygon){
          this.polygonsList[r.id].geometry.getCoordinates()[0].forEach(point => {
            if (this.regionPolygon.geometry.contains(point)) {
              if ((r.orderToTrucking && this.orderToTrucking) || (r.orderToMover && this.orderToMover) || (r.orderToFurniture && this.orderToFurniture)) {
                has = true
                return true
              }
           }
        })
          regionPoints.forEach(point => {
            if (this.polygonsList[r.id].geometry.contains(point)) {
              if ((r.orderToTrucking && this.orderToTrucking) || (r.orderToMover && this.orderToMover) || (r.orderToFurniture && this.orderToFurniture)) {
                has = true
                return true
              }
            }
          })
        }
      })
      return has;
    }
  }
}
</script>
